var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 34.225,
    viewBox: "0 0 53 34.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "quotation",
    d: "M7.416,40.565a10.906,10.906,0,0,1-1.533-.077A3.573,3.573,0,0,1,3.69,34.355a7.958,7.958,0,0,0,2.653-6.379,11.47,11.47,0,0,1-5.566-13.8A10.734,10.734,0,0,1,3.49,9.9,11.562,11.562,0,0,1,15.573,6.969a12.926,12.926,0,0,1,8.664,10.35,19.55,19.55,0,0,1-1.886,12.42v.123C17.628,37.284,13.12,40.565,7.416,40.565Zm-.567-3.849c3.389.169,7.207-.981,12.144-8.832a15.84,15.84,0,0,0,1.533-9.814A9.2,9.2,0,0,0,14.393,10.6,7.667,7.667,0,0,0,6.25,12.6,6.977,6.977,0,0,0,4.5,15.418a7.667,7.667,0,0,0,4.37,9.507,1.917,1.917,0,0,1,1.165,1.4A11.516,11.516,0,0,1,6.848,36.716Zm13.8-7.866ZM36.074,40.565a10.8,10.8,0,0,1-1.533-.077,3.573,3.573,0,0,1-2.193-6.133A7.958,7.958,0,0,0,35,27.976a11.485,11.485,0,0,1-5.566-13.8A10.872,10.872,0,0,1,32.1,9.9,11.577,11.577,0,0,1,44.216,6.969a12.9,12.9,0,0,1,8.664,10.35,19.55,19.55,0,0,1-1.886,12.42.9.9,0,0,1,0,.123C46.287,37.284,41.763,40.565,36.074,40.565Zm-.583-3.849c3.4.169,7.207-.981,12.16-8.832a15.656,15.656,0,0,0,1.533-9.814.552.552,0,0,0,0-.153A9.047,9.047,0,0,0,43.051,10.6,7.667,7.667,0,0,0,34.909,12.6a6.777,6.777,0,0,0-1.7,2.821,7.667,7.667,0,0,0,4.37,9.507,1.932,1.932,0,0,1,1.15,1.4,11.485,11.485,0,0,1-3.235,10.4Zm13.8-7.866Z",
    transform: "translate(53.184 40.565) rotate(180)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotation);
export default __webpack_public_path__ + "static/media/quotation.fc602466420e80d38f91ee8a39c227c6.svg";
export { ForwardRef as ReactComponent };